import { Stack, Typography, useTheme } from "@mui/material";
import type { LucideIcon } from "lucide-react";
import type { FC } from "react";

type Props = {
	icon: LucideIcon;
	text: string;
};

export const AdvisorContactLine: FC<Props> = ({ icon: Icon, text }) => {
	const theme = useTheme();

	return (
		<Stack direction="row" alignItems="center" gap={0.6}>
			<Icon size={theme.iconSize.sm} color={theme.palette.grey[500]} />
			<Typography variant="body2" color={theme.palette.grey[700]}>
				{text}
			</Typography>
		</Stack>
	);
};
